import { forwardRef, memo, useCallback, useContext } from "react";
import { PopoverContext } from "../Popover.context";
import { PopoverPopupProps } from "./types";
import type { FC } from "react";
import * as Styled from './Popup.styled';
import { WithStyle } from "utils/WithStyle";

const Component: FC<PopoverPopupProps> = memo(
    forwardRef(
        (
            {
                id = "popover-popup",
                bgColor = "white",
                distance = "0px",
                placement = "bottom",
                withArrow = false,
                fullWidth = false,
                fullHeight = false,
                ...resProps
            },
            ref
        ) => {
            const { isOpen } = useContext(PopoverContext),
                stopPropagation = useCallback(
                    (e: React.MouseEvent) => e.stopPropagation(),
                    []
                );

            return isOpen ? (
                <Styled.Popup
                    ref={ref}
                    onClick={stopPropagation}
                    id={id}
                    bgColor={bgColor}
                    distance={distance}
                    placement={placement}
                    withArrow={withArrow}
                    fullWidth={fullWidth}
                    fullHeight={fullHeight}
                    {...resProps}
                />
            ) : null;
        }
    )
);

Component.displayName = "Popup";
export const Popup: FC<PopoverPopupProps> & WithStyle = Object.assign(
    Component,
    { Style: Styled.Popup }
);
